import { Component, OnInit} from '@angular/core';
import { MatTableDataSource, MatSort } from '@angular/material';
import { AppHttpService } from '../AppServices/app.httpservices';
import { Project } from '../Models/Project';
import { Router, ActivatedRoute } from '@angular/router';
import { AppAuthenticationService } from '../AppServices/app.authentication';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { DeleteComponent } from '../delete/delete.component';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-admin-project-list',
  templateUrl: './admin-project-list.component.html',
  styleUrls: ['./admin-project-list.component.css']
})
export class AdminProjectListComponent implements OnInit {

  dataSource: Array<Project>;
  isUpdated = "0";
  isLoading = false;

  displayedColumns: string[] = ['title', 'description', 'imageFile', 'action'];
  constructor(private httpClient: AppHttpService, private router: Router,
    private authService: AppAuthenticationService,
    private route: ActivatedRoute,
    public dialog: MatDialog) { }
  
  ngOnInit() {
    this.isLoading = true;
    this.httpClient.get<Array<Project>>('api/Projects/Get', null).subscribe(data => {
        this.dataSource = data;
        this.isLoading = false;
    });
    this.route.params.subscribe(params => {
      this.isUpdated = params['updated'];
    });
  }

  openDialog(project: Project): void {
    const dialogRef = this.dialog.open(DeleteComponent, {
      width: '470px',
      data: { projectId: project.projectId}
    });

    dialogRef.afterClosed().subscribe(result => {
        this.RemoveProject(result);
    });
  }


  EditProject(project: Project) {
     
    this.router.navigate(['Admin/Project/' + project.projectId]);
  }

  RemoveProject(projectId) {
    this.isUpdated = "0";
    const params = new HttpParams().append('ProjectId', projectId);
    this.httpClient.get<Array<Project>>('api/Projects/DeleteProject', params).subscribe(data => {
      this.dataSource = data;
  });

  }

  AddProject() {
    this.router.navigate(['Admin/Project']);
  }

  LogOff() {
    this.authService.clearToken();
    window.location.href = "https://www.farkasfloors.com/Home";
  }

}



